import uiComponents from '@sparklayer-io/spark-dash-ui/i18n/en/components';
import b2bFlowDiagram from './b2b-flow-diagram.json' with { type: 'json' };
import credentialField from './credential-field.json' with { type: 'json' };
import sortableList from './sortable-list.json' with { type: 'json' };
import sparkjsUpgradeAlert from './sparkjs-upgrade-alert.json' with { type: 'json' };

export default {
  ...uiComponents,
  b2b_flow_diagram: b2bFlowDiagram,
  credential_field: credentialField,
  sortable_list: sortableList,
  sparkjs_upgrade_alert: sparkjsUpgradeAlert,
};
